import { useThemeMode } from '@naro/krene-theme';
import { resolveThemeImage, type ThemeImageKey } from '../config/themeImages';

/**
 * 按当前生效的明暗模式取图，返回值可直接给 <img src>。
 * 映射表在 src/config/themeImages.ts。
 *
 * 必须在 <ThemeModeProvider> 内使用（useThemeMode 在 Provider 外会抛错）；
 * App.tsx 里 Provider 已包住整个 <Router>，路由内组件都可直接用。
 *
 * 用法：
 *   const emptyCover = useThemeImage('emptyBoardCover');
 */
export function useThemeImage(key: ThemeImageKey): string {
    const { resolvedMode } = useThemeMode();
    return resolveThemeImage(key, resolvedMode);
}
